var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "order-summary" },
    [
      _c("div", { staticClass: "section-title" }, [
        _c("h2", [_vm._v(_vm._s(_vm.getLangString("orderSummaryTitle")))]),
      ]),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "order-summary-container section-card" },
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("div", { staticClass: "order-body" }, [
                  _c("div", { staticClass: "order-type order-field" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("\n              Wine Club\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.getSelectedOrderTypeObject.title) +
                          "\n            "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "order-frequency order-field" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        "\n              Delivery Frequency\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.selectedFrequency) +
                          "\n            "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "order-quantity order-field" }, [
                    _c("div", { staticClass: "title-container" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v("\n                Quantity\n              "),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.selectedQuantity) +
                            "\n              "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.isCustomOrder
                      ? _c(
                          "div",
                          { staticClass: "products" },
                          [
                            _vm._l(_vm.productList, function (product, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "product" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "product-image" },
                                    [
                                      _c("AImage", {
                                        attrs: {
                                          img: product.image,
                                          preset: "wineproductteaser",
                                          responsive: "",
                                          contain: "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "product-quantity" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(product.quantity) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "product-title" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm._f("formatEntities")(
                                            product.title
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "product-price" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(product.price) +
                                        "\n                "
                                    ),
                                  ]),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm.containsInvalidProducts
                              ? _c("div", { staticClass: "product-message" }, [
                                  _c(
                                    "span",
                                    { staticClass: "product-notice" },
                                    [_vm._v("Note:")]
                                  ),
                                  _vm._v(
                                    " This order contains invalid or missing products. Please update this order as soon as possible, as it cannot be processed until this error is resolved.\n              "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "subtotal" }, [
                    _c("div", { staticClass: "subtotal-title" }, [
                      _vm._v("\n              Subtotal\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "subtotal-price" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.subtotal) +
                          "\n            "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.discount && _vm.showRrp
                    ? _c("div", { staticClass: "discount" }, [
                        _c("div", { staticClass: "discount-title" }, [
                          _vm._v("\n              Discount\n            "),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "discount-price" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.discount) +
                              "\n            "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shipping
                    ? _c("div", { staticClass: "shipping" }, [
                        _c("div", { staticClass: "shipping-title" }, [
                          _vm._v("\n              Shipping\n            "),
                        ]),
                        _vm._v(" "),
                        _vm.shippingCalculated
                          ? _c("div", { staticClass: "shipping-price" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.shipping) +
                                  "\n            "
                              ),
                            ])
                          : _c("div", { staticClass: "shipping-price" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.getLangString("shippingCalculating")
                                  ) +
                                  "\n            "
                              ),
                            ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "total-container" }, [
                    _c(
                      "div",
                      { staticClass: "order-actions" },
                      [
                        !_vm.orderLocked
                          ? _c(
                              "b-btn",
                              {
                                staticClass: "change-order-button",
                                attrs: { variant: "outline-primary" },
                                on: { click: _vm.changeOrder },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.getLangString("changeOrderButton")
                                    ) +
                                    "\n              "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.orderLocked
                          ? _c(
                              "b-btn",
                              {
                                staticClass: "clear-order-button",
                                attrs: { variant: "outline-primary" },
                                on: { click: _vm.clearOrder },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.getLangString("clearOrderButton")
                                    ) +
                                    "\n              "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.orderId
                          ? _c(
                              "b-btn",
                              {
                                staticClass: "cancel-button",
                                attrs: { variant: "outline-primary" },
                                on: { click: _vm.cancelOrder },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.getLangString("cancelOrderButton")
                                    ) +
                                    "\n              "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "total" }, [
                      _c("div", { staticClass: "total-title" }, [
                        _vm._v("\n                Total\n              "),
                      ]),
                      _vm._v(" "),
                      _vm.shippingCalculated
                        ? _c("div", { staticClass: "total-price" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.total) +
                                "\n              "
                            ),
                          ])
                        : _c("div", { staticClass: "total-calculating" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.getLangString("shippingCalculating")
                                ) +
                                "\n              "
                            ),
                          ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }